import React, { Component } from 'react';

class Wrap extends Component {
  render() {
    return (
      <div className="Wrap  wrap:l m-x:a p:s">
        {this.props.children}
      </div>
    );
  }
}

export default Wrap;



// WEBPACK FOOTER //
// ./src/components/Wrap.js